module.exports = __webpack_public_path__ + "static/media/theme.9b618ae4.gif";